const guestValidateMapper = (response) => {
    if (response)
        return {
            message: response.msg,
            registeredDate: response.regDt,
            uniqueID: response.unId,
            OTPValidated: true,
            isClient: response.isCli,
            isGuest: response.isGuest,
        };
    return {};
};
export default guestValidateMapper;
